import { loadScript } from "./loadScript";
import { apiClient } from "@/services/apiClient";
import { API_URLS } from "@/constants/urls";
import { RAZORPAY_SDK_URL } from "@/constants";
import { toast } from "sonner";

export async function razorPayCheckoutHandler(amount, currency, planID, planName, type = "subscription") {


    async function verifyPayment(payment_id, signature, subscription_id) {

        try {
            const response = await apiClient.post(API_URLS.CONFIRM_SUBSCRIPTION_PAYMENT, {
                subscription_id,
                razorpay_key: signature,
                payment_id
            })

            return response.status

        } catch (error) {
            return error.status
        }

    }

    const isLoaded = await loadScript(RAZORPAY_SDK_URL);

    if (!isLoaded) {
        toast("Failed to load Razorpay SDK");
        return {
            status: false,
            type: "script_load_failed"
        };
    }

    if (type === "regular") {
        return new Promise(async (resolve) => {
            try {
                const orderResponse = await apiClient.post(API_URLS.RAZORPAY_ORDER_CREATION, {
                    price: Number(amount),
                    currency: currency,
                    plan_id: planID,
                    plan_name: planName,
                });

                const response = orderResponse?.data;


                const options = {
                    key: response?.razorpay_key,
                    amount: response?.amount,
                    currency: response?.currency,
                    // name: response?.bussiness_name,
                    // description: response?.description,
                    image: "https://mediaprobuzz.s3.us-east-1.amazonaws.com/user_1099942534/kldsnkls/prowen+logo.png",
                    order_id: response.order_id,
                    handler: async function (paymentResponse) {
                        restoreTransforms();
                        resolve(true);
                    },
                    modal: {
                        ondismiss: function () {
                            restoreTransforms();
                            resolve(false);
                        },
                    },
                    prefill: {
                        name: response?.user_info?.full_name,
                        email: response?.user_info?.email,
                        // contact: response?.user_info?.contact
                    },
                    config: {
                        display: {
                            hide: [
                                { method: 'paylater' },
                                { method: 'emi' },
                                { method: 'wallet' },
                            ],
                        },
                    },
                    theme: {
                        color: "#3399cc"
                    }
                };

                const paymentObj = new window.Razorpay(options);

                document.activeElement.blur();

                const originalTransforms = [];
                document.querySelectorAll("body *, body").forEach((el) => {
                    const transform = window.getComputedStyle(el).transform;
                    if (transform && transform !== "none") {
                        originalTransforms.push({ el, transform });
                        el.style.transform = "none";
                    }
                });

                const restoreTransforms = () => {
                    originalTransforms.forEach(({ el, transform }) => {
                        el.style.transform = transform;
                    });
                };

                paymentObj.open();

                setTimeout(() => {
                    const iframe = document.querySelector("iframe[src*='razorpay']");
                    if (iframe) {
                        iframe.style.zIndex = "999999";
                        iframe.style.pointerEvents = "auto";
                        iframe.style.display = "block";
                    }
                }, 50);

                paymentObj.on("payment.failed", () => {
                    restoreTransforms();
                    resolve(false);
                });

            } catch (error) {
                toast.error("Unable to process the payment. Please try again.")
                return resolve(false);
            }
        })
    }

    return new Promise(async (resolve) => {
        try {
            const orderResponse = await apiClient.post(API_URLS.RAZORPAY_SUBSCRIPTION_CREATION, {
                price: Number(amount),
                currency: currency,
                plan_id: planID,
                plan_name: planName,
            });

            const response = orderResponse?.data;


            const options = {
                key: response?.razorpay_key,
                // amount: response?.amount,
                // currency: response?.currency,
                name: response?.bussiness_name,
                description: response?.description,
                image: "https://mediaprobuzz.s3.us-east-1.amazonaws.com/user_1099942534/kldsnkls/prowen+logo.png",
                // order_id: response.order_id,
                subscription_id: response.subscription_id,
                handler: async function (paymentResponse) {
                    const response = await verifyPayment(paymentResponse?.razorpay_payment_id, paymentResponse?.razorpay_signature, paymentResponse?.razorpay_subscription_id);
                    if (response !== 200) {
                        resolve(false)
                    }

                    restoreTransforms();
                    resolve(true);
                },
                modal: {
                    ondismiss: function () {
                        restoreTransforms();
                        resolve(false);
                    },
                },
                prefill: {
                    name: response?.user_info?.full_name,
                    email: response?.user_info?.email,
                    contact: response?.user_info?.contact
                    // contact: 9659231806
                },
                config: {
                    display: {
                        hide: [
                            { method: 'paylater' },
                            { method: 'emi' },
                            { method: 'wallet' },
                        ],
                    },
                },
                theme: {
                    color: "#3399cc"
                }
            };

            const paymentObj = new window.Razorpay(options);

            document.activeElement.blur();

            const originalTransforms = [];
            document.querySelectorAll("body *, body").forEach((el) => {
                const transform = window.getComputedStyle(el).transform;
                if (transform && transform !== "none") {
                    originalTransforms.push({ el, transform });
                    el.style.transform = "none";
                }
            });

            const restoreTransforms = () => {
                originalTransforms.forEach(({ el, transform }) => {
                    el.style.transform = transform;
                });
            };

            paymentObj.open();

            setTimeout(() => {
                const iframe = document.querySelector("iframe[src*='razorpay']");
                if (iframe) {
                    iframe.style.zIndex = "999999";
                    iframe.style.pointerEvents = "auto";
                    iframe.style.display = "block";
                }
            }, 50);

            paymentObj.on("payment.failed", () => {
                restoreTransforms();
                resolve(false);
            });

        } catch (error) {
            toast.error("Unable to process the payment. Please try again.")
            console.error(error)
            return resolve(false);
        }
    });
}

export default razorPayCheckoutHandler;
